/* global window */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Flex, Box } from 'reflexbox';
import { Checkbox, Text } from 'rebass';

import config from 'frontend/config';
import actions from 'frontend/state/actions';
import { selectors as formSelectors } from 'frontend/state/reducers/simbot/form';

const TabOptions = ({ openSimInNewTab, onChangeNewTab }) => {
  if (!window.Notification) {
    return null;
  }
  return (
    <Flex mb={2}>
      <Box mr={1}>
        <Checkbox
          name="openReportInNewTab"
          label="Open sim in new tab"
          checked={openSimInNewTab}
          onChange={onChangeNewTab}
          backgroundColor={config.colors.black}
        />
      </Box>
      <Box>
        <Text small>
          <a
            href="https://support.raidbots.com/article/67-open-sim-in-a-new-tab"
          >
            More Info / Troubleshooting
          </a>
        </Text>
      </Box>
    </Flex>
  );
};

TabOptions.propTypes = {
  openSimInNewTab: PropTypes.bool.isRequired,

  onChangeNewTab: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  openSimInNewTab: formSelectors.openSimInNewTab(state),
});

const mapDispatchToProps = {
  onChangeNewTab: actions.toggleOpenSimInNewTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(TabOptions);
